"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AlertBanner_1 = require("./AlertBanner");
exports.default = AlertBanner_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/AlertBanner/index.js
// module id = 1740
// module chunks = 8